import { render, staticRenderFns } from "./WordUpload.vue?vue&type=template&id=09bce136&scoped=true"
import script from "./WordUpload.vue?vue&type=script&lang=ts"
export * from "./WordUpload.vue?vue&type=script&lang=ts"
import style0 from "./WordUpload.vue?vue&type=style&index=0&id=09bce136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bce136",
  null
  
)

export default component.exports